module.exports = __webpack_public_path__ + "icon-plus-2.png?a9f0723289447b25b2247e038a5d6326";


//////////////////
// WEBPACK FOOTER
// ./Content/img/icon-plus-2.png
// module id = 43
// module chunks = 1